[
  {
    "code": "SD-NB",
    "name": "Blue Nile"
  },
  {
    "code": "SD-GD",
    "name": "Gedaref"
  },
  {
    "code": "SD-GZ",
    "name": "Gezira"
  },
  {
    "code": "SD-KA",
    "name": "Kassala"
  },
  {
    "code": "SD-KH",
    "name": "Khartoum"
  },
  {
    "code": "SD-DN",
    "name": "North Darfur"
  },
  {
    "code": "SD-KN",
    "name": "North Kordofan"
  },
  {
    "code": "SD-NO",
    "name": "Northern"
  },
  {
    "code": "SD-RS",
    "name": "Red Sea"
  },
  {
    "code": "SD-NR",
    "name": "River Nile"
  },
  {
    "code": "SD-SI",
    "name": "Sennar"
  },
  {
    "code": "SD-DS",
    "name": "South Darfur"
  },
  {
    "code": "SD-KS",
    "name": "South Kordofan"
  },
  {
    "code": "SD-DW",
    "name": "West Darfur"
  },
  {
    "code": "SD-NW",
    "name": "White Nile"
  }
]